// 因代理系統轉給外部 PM 系統處理，所以不需要此套件 (此套件極肥)

// 若有需要請參照以下步驟：

// 1. 安裝此套件：`npm install vue-tel-input@4.4.0 -S`
// 2. 解開此檔案的註解
// 3. `<使用的模板代號>/nuxt.config.js` 增加 plugins 項目： `{ src: '../plugins/vue-tel-input.js', ssr: false },`
// 4. 如有樣式變更需求，請依照 vue-tel-input 提供的 css 新增到 `<使用的模板代號>/assets/sass/vendors/vue-tel-input/_vue-tel-input.scss`，
//    並且在 global scss 那邊 import 此 scss 檔案

import Vue from 'vue'
import VueTelInput from 'vue-tel-input'

// import '../assets/sass/vendors/vue-tel-input/_vue-tel-input.scss'

Vue.use(VueTelInput)
